module.exports = __webpack_public_path__ + "img/vip-1.4a6b0d2c.png";